angular.module('filters').filter('membershipPlanClassLimitFilter', ["$filter", function($filter) {
  return function(plan) {
    if (plan.classes_unlimited) {
      return 'Unlimited';
    } else {
      return $filter('pluralize')('classes', plan.classes_limit, true);
    }
  };
}]);
